// extracted by mini-css-extract-plugin
module.exports = {"otherProductCell":"OtherProductCell_otherProductCell__u5ThN"};